<template>
    <div class="pay">
       <!-- 头部 -->
        <div class="header">
            <div class="header-icon">
                <!-- <i class="iconfont icon-shouyintai"></i> -->
                 <img src="../../assets/images/logo.png" alt="" width="40" height="40">
            </div>
            <div class="header-left">
               
                嘉贸
                <!-- <span></span> -->
            </div>
            <div class="header_ce"></div>
            <div class="header-right">收银台</div>
        </div>
        <div class="countDown">
            <div class="top">待支付</div>
            <div class="countDown-bottom">
                <span>剩余时间：</span>
                <van-count-down v-if="showCount" :time="time" @finish="timeFinish" />
            </div>
        </div>
        <el-card class="box-card1" :body-style="{padding: '20px  200px' }">
            <div class="title">支付信息</div>
            <div class="pay-main1" >
              
                <div class="pay-main1_left" >
                    <div class="elCol">
                        <!-- 订单号 -->
                        <div class="orderCode">
                            <div class="left">订单号：</div>
                            <div class="right">{{ userInfo.orderNo}}</div>
                        </div>
                          <!-- 订单时间 -->
                        <div class="orderCode">
                            <div class="left">订单时间：</div>
                            <div class="right">{{ userInfo.createTime}}</div>
                        </div>
                    </div>
                    <div class="elCol" >
                         <!-- 商品名称 -->
                        <div class="orderCode" v-for="(item,index) in userInfo.payOrders" :key="index">
                            <div class="left">商品名称：</div>
                            <div class="right">{{item.orderMsg}}</div>
                        </div>
                       
                    </div>
                   <div class="elCol" >
                       
                        <!-- 订单金额 -->
                        <div class="orderCode" v-for="(item,index) in userInfo.payOrders" :key="index">
                            <div class="left">订单金额：</div>
                            <div class="right">￥{{ item.orderSum ? item.orderSum/100:0.00 }}</div>
                        </div>
                    </div>
                    <div class="elCol" >
                         <!-- 应付金额 -->
                            <div class="amount-payable">
                                <div class="left">应付金额：</div>
                                <div class="right">￥{{ userInfo.orderSum ? userInfo.orderSum/100:0.00 }}</div>
                            </div>
                    </div>
                   
                    
                   
                  
                </div>
             
               
                
               

            </div>
          
        </el-card>
       <!-- 中间支付方式 -->
        <el-card class="box-card" :body-style="{padding: '20px  200px'}">
            <div class="pay-main">
                <!-- 个人/企业 -->
                <div class="geren" v-if="userInfo.userCode=='003'">
                    <div class="left"></div>
                     <div class="rightInput">
                            <el-radio v-model="pay_form.type" label="1" >个人</el-radio>
                            <el-radio v-model="pay_form.type" label="2" >企业</el-radio>
                     </div>
                   
                   
                </div>
                <!-- 企业名称 -->
                <div class="companyName" v-if="pay_form.type=='2'">
                    <div class="left"><span style="color:red">*</span>企业名称：</div>
                    <div class="rightInput">
                        <el-input v-model="pay_form.companyName" placeholder="请输入企业名称"></el-input>
                    </div>
                </div>
                
                <!-- 法定代表人/委托代理人 -->
                <div class="entrustedAgent" v-if="pay_form.type=='2'">
                    <div class="left"><span style="color:red">*</span>法定代表人/委托代理人：</div>
                    <div class="rightInput">
                        <el-input v-model="pay_form.entrustedAgent" placeholder="请输入法定代表人/委托代理人"></el-input>
                    </div>
                </div>
                <div class="companyName" v-else>
                    <div class="left"><span style="color:red">*</span>姓名：</div>
                    <div class="rightInput">
                        <el-input v-model="pay_form.entrustedAgent" placeholder="请输入姓名"></el-input>
                    </div>
                </div>
            
                <!-- 邮箱 -->
                <div class="email" >
                    <div class="left"><span style="color:red">*</span>邮箱：</div>
                    <div class="rightInput">
                        <el-input v-model="pay_form.email" placeholder="请输入邮箱"></el-input>
                    </div>
                </div>
                <!-- 电话号码 -->
                <div class="phoneNumber">
                    <div class="left">手机号：</div>
                    <div class="rightInput">
                        <el-input v-model="pay_form.phoneNumber" placeholder="请输入手机号"></el-input>
                    </div>
                </div>
                <div class="detail">
                    <div class="left"></div>
                     <div class="rightInput">
                            <span>采集*相关信息用于生成《委托代收货款协议》</span>
                    </div>
                    
                </div>
                <!-- 支付方式 -->
                <div class="payWay">
                    <div class="left">支付方式：</div>
                    <div class="right">
                        <!-- tab 栏  选择微信或支付宝-->
                        <div class="alipay" @click="activeName='alipay'" :class="activeName=='alipay'?'selected':''">
                            <i class="iconfont icon-alipay"></i>
                            <span>支付宝扫码支付</span>
                        </div>
                        <div class="wxpay" @click="activeName='wxpay'" :class="activeName=='wxpay'?'selected':''">
                            <i class="iconfont icon-wxpay"></i>
                            <span>微信扫码支付</span>
                        </div>
                    </div>
                </div>
            
                <!-- 确认框 -->
                <div class="checkbox">
                    <el-checkbox size="mini" v-model="checked">阅读并同意<el-button @click.stop="agreement" type="text" style="color:red;">《委托代收货款协议》</el-button>，本人已仔细核对订单信息无误，确定付款</el-checkbox>
                </div>
                <!-- 支付按钮 -->
                <div class="payBtn">
                    <el-button type="danger" @click="pay" :loading="btnLoading">
                        立即支付
                    </el-button>
                </div>
                
            </div>
        </el-card>
      
       
        <!-- 底部 -->
        <div class="bottom">
            <div class="beian">沪ICP备2022031250号</div>
            <div class="companyName">Copyright©2022上海嘉贸供应链管理有限公司 版权所有</div>
        </div>

        <!-- 协议弹出框 -->
        <el-dialog title="《委托代收货款协议》" center :show-close="false" class="aboutDialog" :visible="showDialog" width="40%" >
            <div class="dialogDiv" id="dialogDiv" @scroll="scrollEvent">
                <div style="padding: 0 10px" v-if="userInfo.userCode=='002'">
                    <div>甲方（委托方）</div>
                    <div>公司名称：{{ pay_form.companyName }}</div>
                    <div>法定代表人/委托代理人：{{ pay_form.entrustedAgent }}</div>
                    <div>&nbsp;</div>
                    <div>乙方（受托方）</div>
                    <div>公司名称：：上海嘉贸供应链管理有限公司</div>
                    <div>统一社会信用代码: 91310115MA1HB8WE4N</div>
                    <div>法定代表人：李洋洋</div>
                    <div>&nbsp;</div>
                    <div>甲乙双方按照诚实信用原则，依据相关法律、法规的有关规定，经友好协商,就甲方委托乙方代付（制卡）业务货款事宜达成以下条款，共同遵照执行：</div>
                    <div>&nbsp;</div>
                    <p>1.甲方委托乙方代付甲方在办理制卡业务过程中产生的货款，甲方对乙方代付以上货款行为完全认可，由此造成的一切后果甲方自愿承担相应的法律责任；</p>
                    <p>2.甲方所办理业务为企业行为，甲方委托代理人可以代表甲方向乙方提供甲方的联系方式、甲方名称及甲方相关信息，如甲方拒绝提供可能无法使用相关服务。</p>
                    <p>3.若甲方在线使用支付功能或申请开票等涉及结算、开票功能时，需要完成企业资质认证信息、发票抬头、银行卡信息、经办人身份证号和人脸信息，如果拒绝提供可能无法获得支付或发票开具服务，但不影响其他功能与服务的使用。</p>
                    <p>4.甲方及其委托代理人向乙方完成本协议第1条款项转账后,视为甲方履行了办理制卡业务的付款义务，甲乙双方货款结清；</p>
                    <p>5.协议履行中产生的争议由双方协商解决，协商不成的双方有权向乙方所在地人民法院提起诉讼依法解决。</p>
                    <p>6.甲乙双方完全了解并同意上述条款。</p>
                    <div>&nbsp;</div>
                    <div style="display:flex">
                        <span style="flex:1">甲方： {{ pay_form.companyName }}</span>
                        <span style="flex:1">乙方：上海嘉贸供应链管理有限公司</span>
                    </div>
                    <div style="display:flex">
                        <span style="flex:1">日期: {{ new Date().getFullYear()}}年 {{ new Date().getMonth()+1}}月 {{ new Date().getDate()}}日</span>
                        <span style="flex:1">日期: {{ new Date().getFullYear()}}年 {{ new Date().getMonth()+1}}月 {{ new Date().getDate()}}日</span>
                    </div>
                </div>
                <div style="padding: 0 10px" v-if="pay_form.type=='2'&&userInfo.userCode=='003'">
                    <div>生效日期：{{ new Date().getFullYear()}}年 {{ new Date().getMonth()+1}}月 {{ new Date().getDate()}}日</div>
                    <div>甲方（委托方）</div>
                    <div>公司名称: {{ pay_form.companyName }}</div>
                    <div>法定代表人/委托代理人：{{ pay_form.entrustedAgent }}</div>
                    <!-- <div>联系电话：{{ pay_form.phoneNumber }}</div>
                    <div>电子邮箱：{{ pay_form.email }}</div> -->
                    <div>&nbsp;</div>
                    <div>乙方（受托方）</div>
                    <div>公司名称: 上海嘉贸供应链管理有限公司</div>
                    <div>注册地址: 上海市浦东新区航头镇航都路18号1幢421室 </div>
                    <div>联系电话：021-54363670</div>
                    <p>&nbsp;</p>
                    <div>鉴于，甲方在注册页面上点击“同意”表示同意委托乙方代付业务款项，并经双方友好协商，达成如下协议：</div>
                    <!-- <div>&nbsp;</div> -->
                    <p>一、委托代付业务款项</p>
                    <!-- <div>&nbsp;</div> -->
                    <p>&nbsp;&nbsp; 1、 甲方委托乙方代付业务过程中产生的业务款项，甲方对乙方代付以上业务款项行为完全认可，由此造成的一切后果甲方自愿承担相应的法律责任。</p>
                    <p>&nbsp;&nbsp; 2、 甲方所办理企业及个人业务，甲方委托乙方代理人提供甲方的联系方式、姓名及相关信息，如甲方拒绝提供可能无法使用相关服务。</p>
                    <p>&nbsp;&nbsp; 3、 若甲方在线使用支付功能或申请开票等涉及结算、开票功能时，需要完成身份信息认证、发票抬头、银行卡信息，如果拒绝提供可能无法获得支付或发票开具服务，但不影响其他功能与服务的使用。</p>
                    <p>&nbsp;&nbsp; 4、 甲方及其委托代理人向乙方完成本协议第1条款项转账后，视为甲方履行了办理业务的付款义务，甲乙双方款项结清。</p>
                    <div>&nbsp;</div>
                    <p>二、争议解决</p>
                    <!-- <div>&nbsp;</div> -->
                    <p>&nbsp;&nbsp; 1、 协议履行中产生的争议由双方协商解决，协商不成的，双方有权向乙方所在地人民法院提起诉讼依法解决。</p>
                    <div>&nbsp;</div>
                    <p>三、其他条款</p>
                    <!-- <div>&nbsp;</div> -->
                    <p>&nbsp;&nbsp; 1、 甲乙双方完全了解并同意上述条款。</p>
                    <div>&nbsp;</div>
                    <div style="display:flex">
                        <span style="flex:1">甲方： {{ pay_form.companyName }}</span>
                        <span style="flex:1">乙方：上海嘉贸供应链管理有限公司</span>
                    </div>
                    <div style="display:flex">
                        <span style="flex:1">日期: {{ new Date().getFullYear()}}年 {{ new Date().getMonth()+1}}月 {{ new Date().getDate()}}日</span>
                        <span style="flex:1">日期: {{ new Date().getFullYear()}}年 {{ new Date().getMonth()+1}}月 {{ new Date().getDate()}}日</span>
                    </div>
                </div>
                <div style="padding: 0 10px" v-if="pay_form.type=='1'&&userInfo.userCode=='003'">
                    <div>生效日期：{{ new Date().getFullYear()}}年 {{ new Date().getMonth()+1}}月 {{ new Date().getDate()}}日</div>
                    <div>甲方（委托方）</div>
                    <div>用户姓名：{{ pay_form.entrustedAgent }}</div>
                    <!-- <div>联系电话：{{ pay_form.phoneNumber }}</div>
                    <div>电子邮箱：{{ pay_form.email }}</div> -->
                    <div>&nbsp;</div>
                    <div>乙方（受托方）</div>
                    <div>公司名称: 上海嘉贸供应链管理有限公司</div>
                    <div>注册地址: 上海市浦东新区航头镇航都路18号1幢421室 </div>
                    <div>联系电话：021-54363670</div>
                    <p>&nbsp;</p>
                    <div>鉴于，甲方在注册页面上点击“同意”表示同意委托乙方代付业务款项，并经双方友好协商，达成如下协议：</div>
                    <!-- <div>&nbsp;</div> -->
                    <p>一、委托代付业务款项</p>
                    <!-- <div>&nbsp;</div> -->
                    <p>&nbsp;&nbsp; 1、 甲方委托乙方代付业务过程中产生的业务款项，甲方对乙方代付以上业务款项行为完全认可，由此造成的一切后果甲方自愿承担相应的法律责任。</p>
                    <p>&nbsp;&nbsp; 2、 甲方所办理企业及个人业务，甲方委托乙方代理人提供甲方的联系方式、姓名及相关信息，如甲方拒绝提供可能无法使用相关服务。</p>
                    <p>&nbsp;&nbsp; 3、 若甲方在线使用支付功能或申请开票等涉及结算、开票功能时，需要完成身份信息认证、发票抬头、银行卡信息，如果拒绝提供可能无法获得支付或发票开具服务，但不影响其他功能与服务的使用。</p>
                    <p>&nbsp;&nbsp; 4、 甲方及其委托代理人向乙方完成本协议第1条款项转账后，视为甲方履行了办理业务的付款义务，甲乙双方款项结清。</p>
                    <div>&nbsp;</div>
                    <p>二、争议解决</p>
                    <!-- <div>&nbsp;</div> -->
                    <p>&nbsp;&nbsp; 1、 协议履行中产生的争议由双方协商解决，协商不成的，双方有权向乙方所在地人民法院提起诉讼依法解决。</p>
                    <div>&nbsp;</div>
                    <p>三、其他条款</p>
                    <!-- <div>&nbsp;</div> -->
                    <p>&nbsp;&nbsp; 1、 甲乙双方完全了解并同意上述条款。</p>
                    <div>&nbsp;</div>
                    <div style="display:flex">
                        <span style="flex:1">甲方： {{ pay_form.entrustedAgent }}</span>
                        <span style="flex:1">乙方：上海嘉贸供应链管理有限公司</span>
                    </div>
                    <div style="display:flex">
                        <span style="flex:1">日期: {{ new Date().getFullYear()}}年 {{ new Date().getMonth()+1}}月 {{ new Date().getDate()}}日</span>
                        <span style="flex:1">日期: {{ new Date().getFullYear()}}年 {{ new Date().getMonth()+1}}月 {{ new Date().getDate()}}日</span>
                    </div>
                </div>
                
            </div>
            <div class="dialog-bottom">
                <el-button round @click="noAgree">不同意</el-button>
                <el-button type="danger" round :disabled="disabled" @click="agree">同意</el-button>

            </div>
        </el-dialog>

        <!-- 支付宝方式弹窗 -->
        <el-dialog :title="payTitle" center  :show-close="false"  class="payDialog" :close-on-click-modal="false" :visible="showpayDialog" width="20%">
            
                <iframe v-if="activeName=='alipay'" :srcdoc="payAliQRcode" frameborder="no" border="0" marginwidth="0"
                    marginheight="0" scrolling="no" width="200" height="200" style="overflow: hidden;">
                </iframe>

                <div class="wxpay"  v-if="activeName=='wxpay'">
                    <canvas ref="canvas" id="qrCode"></canvas>
             
                </div>
          
          
                <el-button type="success" round plain @click="goBack">返回首页</el-button>
      
           
        </el-dialog>
        <!-- 倒计时结束 触发dialog -->
        <el-dialog title="提示" top="20%" center class="finishDialog" :show-close="false" :close-on-click-modal="false" :visible="showFinishDialog" width="20%" @close="closeFinishDialog">
            <div class="main">该笔订单已超时</div>
            <el-button type="danger" round plain @click="goBack">返回首页</el-button>
        </el-dialog>
        <el-dialog title="提示" top="20%" center class="errorDialog" :show-close="false" :close-on-click-modal="false"
            :visible="showErrorDialog" width="20%" @close="closeErrorDialog">
            <div class="main">未查找到此单号</div>
            <el-button type="danger" round plain @click="goBack">关闭当前页面</el-button>
        </el-dialog>

        <el-dialog title="提示" top="10%" center class="paySDialog" :show-close="false" :close-on-click-modal="false"
            :visible="showPaySucessDialog" width="20%" @close="closeErrorDialog">
            <div class="main">{{ count }}秒后返回首页</div>
            <el-button type="danger" round plain @click="goBack">返回页面</el-button>
        </el-dialog>
    </div>
</template>

<script>
import '../../css/pc.css'
// import moment from 'moment'
import { reqCommonPay } from '../../api/pay'
import qrcode from 'qrcode'
import { decrypt } from '@/utils/AES.js'
import {getConfigKey} from '../../api/getCache'
export default {
   
    data(){
        return {
            activeName:'',
            checked: false,
            time: 30 * 60 * 1000,
            // time: 1 * 10 * 1000,
            showDialog:false,
            disabled:true,
            showpayDialog:false,
            payTitle:'',
            payAliQRcode:null,
            btnLoading:false,
            showFinishDialog:false,
            showCount:true,
            userInfo:{},
            showErrorDialog:false,

            pay_form:{
                type:'2',
                email:null,
                phoneNumber:null,
                companyName:null,
                entrustedAgent:null
            },

            T: '',//定时器的ID
            showPaySucessDialog:false,
            count:0
        }
    },
    created(){
       
        if (location.search) {
            // console.log(decodeURIComponent(location.search));
            let code = decodeURIComponent(location.search)
            // let newCode = code.slice(1).replace(/\s/g, '+')

            // let code1 = JSON.parse(decrypt(code))
            // console.log(code.slice(1));
            this.getOrderInfo(decrypt(code.slice(1)))
        }else {
            // 404
            this.showErrorDialog=true
            this.showCount=false
        }
       
      
    },
    mounted() {
        // console.log(moment().format('YYYYMMDDHHmmss') +this.randomString(false, 10));
        
    },


    methods:{
        async getOrderInfo(code){
            // console.log(code);
            const res = await reqCommonPay({ orderNo: code },'002')
            // console.log(res);
            if(res.data.code==500){
                this.showErrorDialog=true
                this.showCount = false
            }else {
                this.userInfo = res.data.result
            }
           
        },
        // 回退
        goBack(){
            
            if (this.userInfo.returnWebUrl) {
                // window.history.replaceState(this.userInfo.returnWebUrl)
                // window.location.replace = this.userInfo.returnWebUrl
                let path = window.location.protocol + '//' + this.userInfo.returnWebUrl
                window.location.replace(path)
            }else {
                this.$router.go(-1)
            }
        },
        randomString(randomLen, min, max) {
            var str = "",
                range = min,
                arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
                    'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k',
                    'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v',
                    'w', 'x', 'y', 'z'];
            // 随机产生
            if (randomLen) {
                range = Math.round(Math.random() * (max - min)) + min;
            }
            for (var i = 0; i < range; i++) {
                let pos = Math.round(Math.random() * (arr.length - 1));
                str += arr[pos];
            }
            return str;
        },

        // 
      
        // 当滚动条到底的时候
        scrollEvent(event){
            // console.log(event);
            let el = event.target;
            if (el.scrollTop + el.clientHeight >= el.scrollHeight-1) {
                // console.log('到底啦');
                this.disabled=false
            }
        },
        // 不同意
        noAgree(){
            this.showDialog = false
            this.checked = false
        },
        // 同意协议
        agree(){
            this.showDialog=false
            this.checked=true
        },
        // 轮询查看订单状态
        loopOrderState(){
            this.T = setInterval(async () => {
                const res=await getConfigKey(this.userInfo.orderNo)
                console.log(res);
                if(res.data.result) {
                    // this.showpayDialog=false
                    this.showpayDialog=false
                    clearInterval(this.T)
                    this.showPaySucessDialog=true
                    this.count=5
                    var times = setInterval(() => {
                        this.count--; //递减
                        if (this.count <= 0) {
                            this.goBack()
                          
                            clearInterval(times);
                        }
                    }, 1000); //1000毫秒后

                }
            }, 1000)
        },
        // 点击支付
        async pay(){
            if(this.pay_form.type=='1'){
                if (!this.pay_form.entrustedAgent || this.pay_form.entrustedAgent=='') {
                    return this.$toast('请输入姓名')
                }else if (!this.pay_form.email||this.pay_form.email=='') {
                    return this.$toast('请输入邮箱')
                }else if (this.activeName=='') {
                    return this.$toast('请选择支付方式');
                } else if (!this.checked){
                    return this.$toast('请先勾选协议');
                } 

                // 判断邮箱是否正确
                let reg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,3}){1,2})$/;
                let isok = reg.test(this.pay_form.email);
            
                if(!isok) {
                    return this.$toast('请输入正确的邮箱')
                }
                // 判断手机号格式是正确
                if (this.pay_form.phoneNumber && this.pay_form.phoneNumber!=='') {
                    let reg= /^1\d{10}$/
                        let isok = reg.test(this.pay_form.phoneNumber);
                    if(!isok) {
                        return this.$toast('请输入正确的手机号')
                    }
                }

                     // 如果是支付宝
                
                if (this.activeName == 'alipay') {
                    // 请求确认支付成功
                    this.loopOrderState()
                    this.btnLoading=true
                    // console.log('支付宝支付')
                    this.payTitle ='请用支付宝扫码'
                    if (this.pay_form.phoneNumber) {
                        const res = await reqCommonPay({
                            payChannel: 1402,
                            orderNo: this.userInfo.orderNo,
                            payEmail: this.pay_form.email,
                            payPhone: this.pay_form.phoneNumber,
                            payName: this.pay_form.entrustedAgent,
                            company: ''
                            //    payAmt:1,
                            //    payOrderId: moment().format('YYYYMMDDHHmmss') + this.randomString(false, 10),
                            //    orderNo: moment().format('YYYYMMDDHHmmss') + this.randomString(false, 10),
                            //    returnUrl:'www.baidu.com',
                            //    returnWebUrl:'www.baidu.com',
                            //    notes:'制卡以及物流费'
                        },this.userInfo.userCode)
                        // console.log(res);
                        if (res.data.code == 200 && res.data.result !== null) {
                            this.payAliQRcode = res.data.result.code_url
                            // console.log(res.data.result.code_url);
                            this.btnLoading = false
                            this.showpayDialog = true
                        

                        } else {
                            this.$message.error('支付失败')
                            this.btnLoading = false
                        }

                    }else {
                        const res = await reqCommonPay({
                            payChannel: 1402,
                            orderNo: this.userInfo.orderNo,
                            payEmail: this.pay_form.email,
                            payName: this.pay_form.entrustedAgent,
                            company: ''
                            //    payAmt:1,
                            //    payOrderId: moment().format('YYYYMMDDHHmmss') + this.randomString(false, 10),
                            //    orderNo: moment().format('YYYYMMDDHHmmss') + this.randomString(false, 10),
                            //    returnUrl:'www.baidu.com',
                            //    returnWebUrl:'www.baidu.com',
                            //    notes:'制卡以及物流费'
                        },this.userInfo.userCode)
                        // console.log(res);
                        if (res.data.code == 200 && res.data.result !== null) {
                            this.payAliQRcode = res.data.result.code_url
                            // console.log(res.data.result.code_url);
                            this.btnLoading = false
                            this.showpayDialog = true
                        } else {
                            this.$message.error('支付失败')
                            this.btnLoading = false
                        }

                    }
                

                
                }else {
                    this.loopOrderState()
                    this.btnLoading = true
                    // console.log('微信支付')
                    this.payTitle = '请用微信扫码'
                    if (this.pay_form.phoneNumber)  {
                        const res = await reqCommonPay({
                            payChannel: 1401,
                            orderNo: this.userInfo.orderNo,
                            payEmail: this.pay_form.email,
                            payPhone: this.pay_form.phoneNumber,
                            payName: this.pay_form.entrustedAgent,
                            company: ''
                            // payAmt: 1,
                            // payOrderId: moment().format('YYYYMMDDHHmmss') + this.randomString(false, 10),
                            // orderNo: moment().format('YYYYMMDDHHmmss') + this.randomString(false, 10),
                            // returnUrl: 'www.baidu.com',
                            // returnWebUrl: 'www.baidu.com',
                            // notes: '制卡以及物流费'
                        },this.userInfo.userCode)

                        if (res.data.code == 200 && res.data.result !== null) {
                            // console.log(res.data.result.code_url);
                            let wxcode = res.data.result.code_url




                            this.btnLoading = false
                            this.showpayDialog = true
                            this.$nextTick(() => {
                                qrcode.toCanvas(this.$refs.canvas, wxcode, { width: 200, height: 200 })
                            })
                        } else {
                            this.$message.error('支付失败')
                            this.btnLoading = false
                        }
                    }else {
                        const res = await reqCommonPay({
                            payChannel: 1401,
                            orderNo: this.userInfo.orderNo,
                            payEmail: this.pay_form.email,
                            payName: this.pay_form.entrustedAgent,
                            company: ''
                            // payAmt: 1,
                            // payOrderId: moment().format('YYYYMMDDHHmmss') + this.randomString(false, 10),
                            // orderNo: moment().format('YYYYMMDDHHmmss') + this.randomString(false, 10),
                            // returnUrl: 'www.baidu.com',
                            // returnWebUrl: 'www.baidu.com',
                            // notes: '制卡以及物流费'
                        },this.userInfo.userCode)

                        if (res.data.code == 200 && res.data.result !== null) {
                            // console.log(res.data.result.code_url);
                            let wxcode = res.data.result.code_url




                            this.btnLoading = false
                            this.showpayDialog = true
                            this.$nextTick(() => {
                                qrcode.toCanvas(this.$refs.canvas, wxcode, { width: 200, height: 200 })
                            })
                        } else {
                            this.$message.error('支付失败')
                            this.btnLoading = false
                        }
                    }
                
                }
            }else {
                if (!this.pay_form.companyName || this.pay_form.companyName=='') {
                    return this.$toast('请输入企业名称')
                }else if (!this.pay_form.entrustedAgent || this.pay_form.entrustedAgent=='') {
                    return this.$toast('请输入法定代表人/委托代理人')
                }else if (!this.pay_form.email||this.pay_form.email=='') {
                    return this.$toast('请输入邮箱')
                }else if (this.activeName=='') {
                    return this.$toast('请选择支付方式');
                } else if (!this.checked){
                    return this.$toast('请先勾选协议');
                } 
                // 判断邮箱是否正确
                let reg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,3}){1,2})$/;
                let isok = reg.test(this.pay_form.email);
            
                if(!isok) {
                    return this.$toast('请输入正确的邮箱')
                }
                // 判断手机号格式是正确
                if (this.pay_form.phoneNumber && this.pay_form.phoneNumber!=='') {
                    let reg= /^1\d{10}$/
                        let isok = reg.test(this.pay_form.phoneNumber);
                    if(!isok) {
                        return this.$toast('请输入正确的手机号')
                    }
                }
                // 如果是支付宝
                
                if (this.activeName == 'alipay') {
                    // 请求确认支付成功
                    this.loopOrderState()
                    this.btnLoading=true
                    // console.log('支付宝支付')
                    this.payTitle ='请用支付宝扫码'
                    if (this.pay_form.phoneNumber) {
                        const res = await reqCommonPay({
                            payChannel: 1402,
                            orderNo: this.userInfo.orderNo,
                            payEmail: this.pay_form.email,
                            payPhone: this.pay_form.phoneNumber,
                            payName: this.pay_form.entrustedAgent,
                            company: this.pay_form.companyName
                            //    payAmt:1,
                            //    payOrderId: moment().format('YYYYMMDDHHmmss') + this.randomString(false, 10),
                            //    orderNo: moment().format('YYYYMMDDHHmmss') + this.randomString(false, 10),
                            //    returnUrl:'www.baidu.com',
                            //    returnWebUrl:'www.baidu.com',
                            //    notes:'制卡以及物流费'
                        },this.userInfo.userCode)
                        // console.log(res);
                        if (res.data.code == 200 && res.data.result !== null) {
                            this.payAliQRcode = res.data.result.code_url
                            // console.log(res.data.result.code_url);
                            this.btnLoading = false
                            this.showpayDialog = true
                        

                        } else {
                            this.$message.error('支付失败')
                            this.btnLoading = false
                        }

                    }else {
                        const res = await reqCommonPay({
                            payChannel: 1402,
                            orderNo: this.userInfo.orderNo,
                            payEmail: this.pay_form.email,
                            payName: this.pay_form.entrustedAgent,
                            company: this.pay_form.companyName
                            //    payAmt:1,
                            //    payOrderId: moment().format('YYYYMMDDHHmmss') + this.randomString(false, 10),
                            //    orderNo: moment().format('YYYYMMDDHHmmss') + this.randomString(false, 10),
                            //    returnUrl:'www.baidu.com',
                            //    returnWebUrl:'www.baidu.com',
                            //    notes:'制卡以及物流费'
                        },this.userInfo.userCode)
                        // console.log(res);
                        if (res.data.code == 200 && res.data.result !== null) {
                            this.payAliQRcode = res.data.result.code_url
                            // console.log(res.data.result.code_url);
                            this.btnLoading = false
                            this.showpayDialog = true
                        } else {
                            this.$message.error('支付失败')
                            this.btnLoading = false
                        }

                    }
                

                
                }else {
                    this.loopOrderState()
                    this.btnLoading = true
                    // console.log('微信支付')
                    this.payTitle = '请用微信扫码'
                    if (this.pay_form.phoneNumber)  {
                        const res = await reqCommonPay({
                            payChannel: 1401,
                            orderNo: this.userInfo.orderNo,
                            payEmail: this.pay_form.email,
                            payPhone: this.pay_form.phoneNumber,
                            payName: this.pay_form.entrustedAgent,
                            company: this.pay_form.companyName
                            // payAmt: 1,
                            // payOrderId: moment().format('YYYYMMDDHHmmss') + this.randomString(false, 10),
                            // orderNo: moment().format('YYYYMMDDHHmmss') + this.randomString(false, 10),
                            // returnUrl: 'www.baidu.com',
                            // returnWebUrl: 'www.baidu.com',
                            // notes: '制卡以及物流费'
                        },this.userInfo.userCode)

                        if (res.data.code == 200 && res.data.result !== null) {
                            // console.log(res.data.result.code_url);
                            let wxcode = res.data.result.code_url




                            this.btnLoading = false
                            this.showpayDialog = true
                            this.$nextTick(() => {
                                qrcode.toCanvas(this.$refs.canvas, wxcode, { width: 200, height: 200 })
                            })
                        } else {
                            this.$message.error('支付失败')
                            this.btnLoading = false
                        }
                    }else {
                        const res = await reqCommonPay({
                            payChannel: 1401,
                            orderNo: this.userInfo.orderNo,
                            payEmail: this.pay_form.email,
                            payName: this.pay_form.entrustedAgent,
                            company: this.pay_form.companyName
                            // payAmt: 1,
                            // payOrderId: moment().format('YYYYMMDDHHmmss') + this.randomString(false, 10),
                            // orderNo: moment().format('YYYYMMDDHHmmss') + this.randomString(false, 10),
                            // returnUrl: 'www.baidu.com',
                            // returnWebUrl: 'www.baidu.com',
                            // notes: '制卡以及物流费'
                        },this.userInfo.userCode)

                        if (res.data.code == 200 && res.data.result !== null) {
                            // console.log(res.data.result.code_url);
                            let wxcode = res.data.result.code_url




                            this.btnLoading = false
                            this.showpayDialog = true
                            this.$nextTick(() => {
                                qrcode.toCanvas(this.$refs.canvas, wxcode, { width: 200, height: 200 })
                            })
                        } else {
                            this.$message.error('支付失败')
                            this.btnLoading = false
                        }
                    }
                
                }
            }
            
        },
        // 点击协议
        agreement(){
            this.showDialog=true
        },
        // 倒计时结束触发
        timeFinish(){
            // console.log('结束')
            this.showFinishDialog = true
        },
        closeFinishDialog(){
            this.showFinishDialog=false
        },
        closeErrorDialog(){
            this.showErrorDialog=false
        }
    },
    beforeDestroy(){
        clearInterval(this.T)
    }
    
}
</script>

<style>

</style>